import React, { useEffect } from 'react';
import { CreditNoteForm } from '../../Components/Form';
import { FormLayout } from '../../Components';
import { CreditNoteIcon } from '../../Assets/Navigation/NavigationIcons';
import { t } from 'i18next';

const EditCreditNote = (props) => {
  useEffect(() => {
    document.title = t('CreditNote.add_cn');
  }, []);

  return (
    <FormLayout
      title={t('Settings.credit_notes')}
      Icon={CreditNoteIcon}
      subtitle={t('common.edit')}
      closeUrl="/creditnotes"
      iconstyle="credit_general_module_icon"
      layoutBoxClass="uiux-form-redesign"
    >
      <CreditNoteForm
        type="edit"
        id={
          props.idFromHeaderWrapper
            ? props.idFromHeaderWrapper
            : props.match.params.id
        }
        handleToast={props.handleToast}
      />
    </FormLayout>
  );
};

export default EditCreditNote;
